import React, { useState } from 'react';
import Slider from 'react-slick';
import Styles from './styles.module.scss';
import QuoteModal from './QuoteModal';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import H3 from '../../../components/typography/h3';
import { Link } from 'react-router-dom';

import Serviceimg1 from '../../../assets/newhomepageimg/horizontalimg1.webp';
import Serviceimg2 from '../../../assets/newhomepageimg/horizontalimg2.webp';
import Serviceimg3 from '../../../assets/newhomepageimg/horizontalimg3.webp';
import Serviceimg4 from '../../../assets/newhomepageimg/horizontalimg4.webp';
import Serviceimg5 from '../../../assets/newhomepageimg/horizontalimg5.webp';
import Serviceimg6 from '../../../assets/newhomepageimg/horizontalimg6.webp';
import Serviceimg7 from '../../../assets/newhomepageimg/horizontalimg7.webp';

interface Card {
  title: string;
  image: string;
  subtitle: string;
  link: string;
}

const HorizontalScrollSection: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const cards: Card[] = [
    {
      subtitle: "Social Media Marketing",
      title: "Let Your Brand Be Seen, Heard, and Shared on Social Media",
      image: Serviceimg1,
      link: "socialmediamarketing"
    },
    {
      subtitle: "Web & Mobile App Development",
      title: "Modern Websites and Apps That Look Great and Work Even Better",
      image: Serviceimg2,
      link: "/webandmobileapplication"
    },
    {
      subtitle: "Performance Marketing",
      title: "Target the right audience and turn clicks into customers",
      image: Serviceimg7,
      link: "/performancemarketing"
    },
    {
      subtitle: "Branding",
      title: "Make Your Brand Instantly Stand Out in a Crowded Market",
      image: Serviceimg3,
      link: "/branding"
    },
    {
      subtitle: "SEO Marketing",
      title: "Reach the Right Audience at the Right Time with Targeted SEO",
      image: Serviceimg4,
      link: "/seo"
    },
    {
      subtitle: "IT Solutions",
      title: "Connecting Infrastructure, Security, and Support Seamlessly",
      image: Serviceimg5,
      link: "/itsolution"
    },
    {
      subtitle: "360° View Photography & Videography",
      title: "Transforming Real-World Views Into Interactive Visual Stories",
      image: Serviceimg6,
      link: "/photography360view"
    }
  ];

interface ArrowProps {
  onClick?: () => void;
}

const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${Styles.arrow} ${Styles.prev}`} onClick={onClick}>
<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.621485 8.10248L8.80273 1.04701C9.10781 0.784903 9.55469 1.02123 9.55469 1.44447V15.5554C9.55469 15.9787 9.10781 16.215 8.80273 15.9529L0.621485 8.8974C0.387305 8.69545 0.387305 8.30443 0.621485 8.10248Z" fill="#FF2E84"/>
</svg>

  </div>
);

const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${Styles.arrow1} ${Styles.next}`} onClick={onClick}>
   <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.3785 11.1024L7.19727 4.04689C6.89219 3.78478 6.44531 4.02111 6.44531 4.44435V18.5553C6.44531 18.9785 6.89219 19.2149 7.19727 18.9528L15.3785 11.8973C15.6127 11.6953 15.6127 11.3043 15.3785 11.1024Z" fill="white"/>
</svg>

  </div>
);
const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true, 
  autoplaySpeed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "0px",
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    }
  ]
};

  return (
    <div className={Styles.services}>
      <H3>
        <div className={Styles.Digitaltext}>
          <div className={Styles.Digitaltext_2}>
            Discover our services designed to grow your business and digital reach.
          </div>
          <Link to="/talk_us" className="btn btn-small">Let's talk</Link>
        </div>
      </H3>

      <div className={Styles.wrapper}>
        <Slider {...sliderSettings} className={Styles.cardsSlider}>
          {cards.map((card, index) => (
            <div key={index} className={Styles.cardWrapper}>
              <div
                className={Styles.card}
                style={{ backgroundImage: `url(${card.image})` }}
              >
                <div className={Styles.textContent}>
                  <p className={Styles.subtitle}>{card.subtitle}</p>
                  <h2 className={Styles.cardTitle}>{card.title}</h2>
                </div>
                <div className={Styles.overlay}>
                  <div className={Styles.buttonGroup}>
                    <Link
                      to={card.link}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                      <button className={Styles.primaryButton}>Learn More</button>
                    </Link>
                    {/* <button className={Styles.secondaryButton} onClick={handleOpenModal}>
                      Get a Quote
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <QuoteModal isOpen={isModalOpen} onClose={handleCloseModal} />
      </div>
    </div>
  );
};

export default HorizontalScrollSection;
